import { useContext, useRef, useState } from "react";
import DynamicForm from "../../../components/DynamicForm/DynamicForm";
import { UserContext } from "../../../context/UserContext";

import { text_validation, email_validation, UseValidation, phone_validation } from "../../../components/DynamicForm/Helpers/validationMethods";
import { GetSubscriptionTier } from "../../../utils/businessUtils";
import { SettingOption } from "../../../components/SettingOption/setting-option";
import "./subscription-settings.css";

const defaultProps = {
  onChanged: () => {},
};

export default function SubscriptionSettings(props = defaultProps) {
  const { user, loginUser } = useContext(UserContext);

  const valid = useRef(new Map());

  const [autoRenew, setAutoRewnew] = useState(true);

  UseValidation(valid);

  const isValid = () => ![...valid.current.values()].some((v) => v === false);

  const SubscriptionSettingsFields = [
    {
      id: "stripe-cus-id",
      name: "Stripe Customer Id",
      type: "text",
      defaultValue: user.stripeCustomerId ?? "N/A",
      disabled: true,
    },
    {
      id: "subscription-plan",
      name: "Subscription Plan",
      type: "text",
      disabled: true,
      defaultValue: GetSubscriptionTier(user.subscription).toUpperCase(),
    },
  ];

  return (
    <section className="subscription-settings-container">
      <div className="subscription-settings-form-container">
        <DynamicForm id={"subscription-settings-form"} layout={[1, 2]} fields={SubscriptionSettingsFields} />
      </div>

      {/* <SettingOption
        id={"subscription-auto-renew-toggle"}
        controlType={"toggle"}
        defaultValue={autoRenew}
        onChange={(value) => setAutoRewnew(value)}
        description={autoRenew ? "Auto Renew Enabled" : "Auto Renew Disabled"}
      /> */}

      <div className="subscription-settings-buttons">
        <button className="standard-button">Change Subscription Tier</button>
        {/* only show if user is not a free subscription */}
        {user.subscription > 0 && <button className="standard-button btn-red">Cancel Subscription</button>}
      </div>
    </section>
  );
}
